/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".filters-container[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;color:#394042}.result-count-container[_ngcontent-%COMP%]{font-size:14px;margin:auto 5px}.clear-filters-btn[_ngcontent-%COMP%]{width:26px;height:26px;margin:auto 5px;color:#394042;cursor:pointer}.clear-filters-btn[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%]{transition:color .3s ease}.clear-filters-btn[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%]:hover{color:#de393d}"];
export { styles as styles };
